import React from 'react';
import { RUBROS, ACEPTA_ARCHIVOS, abrirComprobante } from '../lib/comprobantes';

// Selector de rubro (Hogar, Impuestos, Empresa, Personal).
export function SelectRubro({ value, onChange, vacio = 'Sin rubro' }) {
  return (
    <select value={value || ''} onChange={e => onChange(e.target.value)}>
      <option value="">{vacio}</option>
      {RUBROS.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
    </select>
  );
}

// Campo para adjuntar un comprobante (foto, capture o PDF). Funciona en celular (cámara o galería) y PC.
export function CampoComprobante({ archivo, onChange, label = '📎 Comprobante (opcional)' }) {
  return (
    <div className="form-group">
      <label>{label}</label>
      <input type="file" accept={ACEPTA_ARCHIVOS} onChange={e => onChange(e.target.files?.[0] || null)} />
      {archivo && (
        <span className="field-hint">
          ✅ {archivo.name} ({Math.max(1, Math.round(archivo.size / 1024))} KB){' '}
          <button type="button" onClick={() => onChange(null)}
            style={{ background: 'none', border: 'none', textDecoration: 'underline', cursor: 'pointer', color: 'inherit', padding: 0 }}>
            quitar
          </button>
        </span>
      )}
    </div>
  );
}

// Lista de comprobantes ya adjuntos, con botón para abrirlos.
export function ListaComprobantes({ comprobantes, onError, onBorrar }) {
  if (!comprobantes?.length) return null;
  const abrir = (c) => abrirComprobante(c).catch(e => onError?.(e.message || String(e)));
  return (
    <div className="form-group">
      <label>Comprobantes adjuntos</label>
      {comprobantes.map(c => (
        <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0' }}>
          <button type="button" className="btn-secondary" style={{ padding: '4px 10px', fontSize: '0.8rem' }} onClick={() => abrir(c)}>
            📎 Ver
          </button>
          <span style={{ fontSize: '0.85rem', flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {c.archivo_nombre || c.concepto}
          </span>
          {onBorrar && (
            <button type="button" className="btn-icon-del small" title="Quitar comprobante" onClick={() => onBorrar(c)}>×</button>
          )}
        </div>
      ))}
    </div>
  );
}
